export default "__VITE_ASSET__DzZaFCZk__"